import React,{Component} from 'react';
import QueryString from 'qs';
import styles from './Sharebar.module.css';
import icon_mail from './content-hub-email-24px.svg';
import icon_twitter from './twitter.svg';
import icon_share from './shareIcon.svg';
import icon_copy from './content-hub-link-24px.svg';
import ReactGA from 'react-ga';

class ShareBar extends Component{
	gaEvent=(action)=>{
		ReactGA.event({
			category:'Social',
			action:action,
		});
  	};
  	state={
    	open:false,
  	};

	toggleActions=()=>{
		this.setState({
			open:this.state.open===false
		});
	};

  	copyToClipboard() {
    	const el=document.createElement('textarea');
    	el.value=window.location.href;
    	document.body.appendChild(el);
    	el.select();
    	document.execCommand('copy');
    	document.body.removeChild(el);
    	this.gaEvent('Link Share');
  	}

	render(){
		let mailtoParams=QueryString.stringify({
				subject:this.props.text,
				body:'Hello, I found the following on the BASF Content Hub. Have a look at '+window.location.href
			}),
			mailtoLink='mailto:?'+mailtoParams,
			twitterParams=QueryString.stringify({
				size:'large',
				text:this.props.text,
				url:window.location.href,
			}),
			twitterLink='https://twitter.com/intent/tweet?'+twitterParams;

		return (
			<React.Fragment>
				<div className={[styles.container, styles[this.props.pos]].join(" ")}>
					<div className={styles.toggle} onClick={this.toggleActions}>
						<img alt="share" className={styles.share_icon} src={icon_share}></img>
					</div>
					<ul className={[styles.menu,this.state.open?styles.open:undefined].join(" ")}>
						<li className={styles.icon}>
							<div title="Copy a link to the clipboard" onClick={()=>this.copyToClipboard()}>
								<img alt="copy" className={styles.share_menu_icon} src={icon_copy}></img>
							</div>
						</li>
						<li className={styles.icon}>
							<a href={twitterLink} title="Share this article on twitter" target="_blank" rel="noopener noreferrer" onClick={()=>this.gaEvent('Twitter Share')}>
								<img alt="twitter" className={styles.share_menu_icon} src={icon_twitter}></img>
							</a>
						</li>
						<li className={styles.icon}>
							<a title="Share this article in Email" href={mailtoLink} onClick={()=>this.gaEvent('Email Share')}>
								<img alt="email" className={styles.share_menu_icon} src={icon_mail}></img>
							</a>
						</li>
					</ul>
				</div>
			</React.Fragment>
		);
  	}
}

export default ShareBar;
